import { useEffect, useState } from "react";
import api from "@api";
import "./DirectoryInsights.css";
import { SPORTS } from "../../utils/sports";

function DirectoryInsights() {
 const [activeTab, setActiveTab] = useState("overview");
 const [summary, setSummary] = useState(null);
 const [loading, setLoading] = useState(false);
 const [sportsBreakdown, setSportsBreakdown] = useState([]);
 const getSportLabel = (sportKey) => {
  return SPORTS.find((sport) => sport.key === sportKey)?.label || sportKey;
 };
 const fetchInsights = async () => {
  try {
   setLoading(true);

   const res = await api.get("/api/admin/directory/insights", {
    withCredentials: true,
   });
   setSummary(res.data.summary);
   setSportsBreakdown(res.data.sportsBreakdown || []);
  } catch (err) {
   console.error("Failed to fetch directory insights", err);
  } finally {
   setLoading(false);
  }
 };

 useEffect(() => {
  fetchInsights();
 }, []);


 return (
  <div className="directory-insights-container">
   <div className="directory-insights-header">
    <div>
     <h2>Directory Insights</h2>
     <p>Master view for counts, cleanup, duplicates, and directory data.</p>
    </div>
   </div>

   <div className="directory-insights-tabs">
    <button
     className={activeTab === "overview" ? "active" : ""}
     onClick={() => setActiveTab("overview")}
    >
     Overview
    </button>

    <button
     className={activeTab === "sports" ? "active" : ""}
     onClick={() => setActiveTab("sports")}
    >
     Sports
    </button>

    <button
     className={activeTab === "locations" ? "active" : ""}
     onClick={() => setActiveTab("locations")}
    >
     Locations
    </button>

    <button
     className={activeTab === "programTypes" ? "active" : ""}
     onClick={() => setActiveTab("programTypes")}
    >
     Program Types
    </button>

    <button
     className={activeTab === "duplicates" ? "active" : ""}
     onClick={() => setActiveTab("duplicates")}
    >
     Duplicates
    </button>

    <button
     className={activeTab === "missingData" ? "active" : ""}
     onClick={() => setActiveTab("missingData")}
    >
     Missing Data
    </button>
   </div>

   <div className="directory-insights-content">
    {activeTab === "overview" && (
     <div>
      <h3>Overview</h3>

      {loading && <p>Loading insights...</p>}

      {!loading && !summary && (
       <p>No insights loaded yet.</p>
      )}

      {!loading && summary && (
       <div className="directory-insights-grid">
        <div className="insight-card">
         <span>Total Listings</span>
         <strong>{summary.totalListings}</strong>
        </div>

        <div className="insight-card">
         <span>Total Programs</span>
         <strong>{summary.totalPrograms}</strong>
        </div>

        <div className="insight-card">
         <span>Total Sports</span>
         <strong>{summary.totalSports}</strong>
        </div>

        <div className="insight-card">
         <span>Total States</span>
         <strong>{summary.totalStates}</strong>
        </div>

        <div className="insight-card">
         <span>Total Cities</span>
         <strong>{summary.totalCities}</strong>
        </div>

        <div className="insight-card warning">
         <span>Missing Website</span>
         <strong>{summary.missingWebsite}</strong>
        </div>

        <div className="insight-card warning">
         <span>Missing Programs</span>
         <strong>{summary.missingPrograms}</strong>
        </div>

        <div className="insight-card danger">
         <span>Possible Duplicates</span>
         <strong>{summary.possibleDuplicates}</strong>
        </div>
       </div>
      )}
     </div>
    )}

    {activeTab === "sports" && (
     <div>
      <h3>Sports Breakdown</h3>

      {sportsBreakdown.length === 0 ? (
       <p>No sports data found.</p>
      ) : (
       <div className="directory-insights-table-wrap">
        <table className="directory-insights-table">
         <thead>
          <tr>
           <th>Sport</th>
           <th>Listings</th>
           <th>Programs</th>
           <th>States</th>
           <th>Cities</th>
          </tr>
         </thead>

         <tbody>
          {sportsBreakdown.map((sport) => (
           <tr key={sport.sport}>
            <td>{getSportLabel(sport.sport)}</td>
            <td>{sport.listings}</td>
            <td>{sport.programs}</td>
            <td>{sport.states}</td>
            <td>{sport.cities}</td>
           </tr>
          ))}
         </tbody>
        </table>
       </div>
      )}
     </div>
    )}
   </div>
  </div>
 );
}

export default DirectoryInsights;